import Vue from 'vue';

import Vuebar from 'vuebar';
import VueCompositionApi, { provide } from '@vue/composition-api';
import { plugin, useProjectTailwindColors } from '@ideavivat/vivat-2';
import NotFound from '@/components/NotFound.vue';
import App from './App.vue';
import router from './router';
import store from './store';

import CommonRichTableWithAxios from './components/CommonRichTableWithAxios.vue';

Vue.use(plugin);

Vue.use(VueCompositionApi);
Vue.use(Vuebar);

useProjectTailwindColors(true);

Vue.component('NotFound', NotFound);
Vue.component('CommonRichTableWithAxios', CommonRichTableWithAxios);

(window as any).BUILD_NOTE = `${process.env.VUE_APP_BUILD_NOTE || 'HMR'}${(window as any).VIVAT_BUILD_NOTE || ''}`;
console.log('Build:', (window as any).BUILD_NOTE);

Vue.config.productionTip = false;

(window as any).Vue = Vue;

new Vue({
  setup() {
    return {};
  },
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
